type CircleProps = {
  color: string
}

export function Circle({ color }: CircleProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 1024 1024"
      fill={color}
    >
      <circle cx="512" cy="512" r="256" fillRule="evenodd" />
    </svg>
  )
}
